import React from "react";
import styled from "styled-components";
import { apolloLineHeightHeaderMainTitle, apolloLineHeightHeaderSecondaryTitle, apolloSpaceInline1HalfX, apolloSpaceInlineHalfX, apolloSpaceInset1HalfX, apolloSpaceInset3X, apolloSpaceStack1X, apolloTextTransformHeaderSecondaryTitle, } from "@nexthink/apollo-tokens";
import Flex from "../box/Flex";
import Text from "../text/Text";
import Box from "../box/Box";
import { HiddenButtonIcon } from "../menu/KebabActionMenu.style";
const truncateStyles = {
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};
export const StyledToolbar = styled(Flex).withConfig({ displayName: "StyledToolbar_APC-7281-productShell", componentId: "sc-1dxzdpn" })(({ theme }) => ({
    alignItems: "center",
    justifyContent: "space-between",
    background: theme.colors.apolloColorBackgroundHeader,
    padding: `0 ${apolloSpaceInset3X} 0 0`,
    height: `calc(${apolloSpaceInset1HalfX} * 2 + ${apolloLineHeightHeaderMainTitle} + ${apolloLineHeightHeaderSecondaryTitle})`,
}));
export const StyledTitleContainer = styled(Flex).withConfig({ displayName: "StyledTitleContainer_APC-7281-productShell", componentId: "sc-56uvun" })({
    padding: `${apolloSpaceInset1HalfX} 0 ${apolloSpaceInset1HalfX} ${apolloSpaceInset3X}`,
    [`&:hover ${HiddenButtonIcon}`]: {
        opacity: 1,
    },
    [`${HiddenButtonIcon}`]: {
        marginLeft: apolloSpaceInlineHalfX,
    },
});
export const StyledMainTitle = styled((props) => React.createElement(Text, Object.assign({ as: "h1", variant: "mainTitle" }, props))).withConfig({ displayName: "StyledMainTitle_APC-7281-productShell", componentId: "sc-76roza" })(truncateStyles);
export const StyledSecondaryTitle = styled((props) => (React.createElement(Text, Object.assign({ as: "h2", variant: "secondaryTitle" }, props)))).withConfig({ displayName: "StyledSecondaryTitle_APC-7281-productShell", componentId: "sc-10cgqtg" })(({ theme }) => (Object.assign(Object.assign({}, truncateStyles), { textTransform: apolloTextTransformHeaderSecondaryTitle, color: theme.colors.apolloColorTextTertiary })));
export const PrimaryActionBox = styled(Box).withConfig({ displayName: "PrimaryActionBox_APC-7281-productShell", componentId: "sc-8ykvle" })({
    display: "inline-flex",
    alignItems: "center",
    padding: `${apolloSpaceInset1HalfX} 0`,
    [`&+&`]: {
        marginLeft: apolloSpaceInlineHalfX,
    },
});
export const ExpandActionBox = styled(Box).withConfig({ displayName: "ExpandActionBox_APC-7281-productShell", componentId: "sc-18vq8qv" })({
    display: "inline-flex",
    alignItems: "center",
    [`${PrimaryActionBox}+&`]: {
        marginLeft: apolloSpaceInline1HalfX,
    },
});
export const StyledExpandableContainer = styled(Flex).withConfig({ displayName: "StyledExpandableContainer_APC-7281-productShell", componentId: "sc-1ecio5j" })(({ theme }) => ({
    background: theme.colors.apolloColorBackgroundHeader,
    padding: `0 ${apolloSpaceInset3X} ${apolloSpaceStack1X}`,
    height: "auto",
}));
//# sourceMappingURL=TitleBar.style.js.map